export default __webpack_public_path__ + "assets/germany-flag.png";